export default {
  getSavedFieldByPath: ({ fields, }) => (path) => {
    const field = fields.find(({ jsonPath, }) => path === jsonPath)
    if (field) {
      return field.unsetValue ? 'not available' : field.proposed_value
    } else {
      return null
    }
  },
  getAllSavedFieldsByPath: ({ fields, }) => (path) => {
    return fields.filter(({ jsonPath, }) => jsonPath.indexOf(path) !== -1)
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/record/modules/challenge/getters.js